import { render, staticRenderFns } from "./MessageLoadingComponent.vue?vue&type=template&id=16993a41&"
import script from "./MessageLoadingComponent.vue?vue&type=script&lang=js&"
export * from "./MessageLoadingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports